import { create } from "zustand";
import type { TransformTool } from "@/types/scene";

interface EditorState {
  selectedObjectId: string | null;
  activeTool: TransformTool;
  walkToActorId: string | null;
  walkDuration: number;
  stoppingDistance: number;
  autoFaceDirection: boolean;
  previewCameraId: string | null;
  fullscreenPreview: boolean;
  cameraBeforeFullscreen: string | null;
  selectObject: (id: string | null) => void;
  setActiveTool: (tool: TransformTool) => void;
  startWalkTo: (actorId: string) => void;
  cancelWalkTo: () => void;
  setWalkDuration: (duration: number) => void;
  setStoppingDistance: (distance: number) => void;
  setAutoFaceDirection: (enabled: boolean) => void;
  previewCamera: (id: string | null) => void;
  startFullscreenPreview: (cameraId: string | null) => void;
  endFullscreenPreview: () => void;
}

export const useEditorStore = create<EditorState>((set) => ({
  selectedObjectId: null,
  activeTool: "translate",
  walkToActorId: null,
  walkDuration: 3,
  stoppingDistance: 1,
  autoFaceDirection: true,
  previewCameraId: null,
  fullscreenPreview: false,
  cameraBeforeFullscreen: null,
  selectObject: (selectedObjectId) => set({ selectedObjectId }),
  setActiveTool: (activeTool) => set({ activeTool }),
  startWalkTo: (walkToActorId) => set({ walkToActorId, activeTool: "select" }),
  cancelWalkTo: () => set({ walkToActorId: null }),
  setWalkDuration: (walkDuration) => set({ walkDuration: Math.max(.1, walkDuration) }),
  setStoppingDistance: (stoppingDistance) => set({ stoppingDistance: Math.max(0, stoppingDistance) }),
  setAutoFaceDirection: (autoFaceDirection) => set({ autoFaceDirection }),
  previewCamera: (previewCameraId) => set({ previewCameraId, walkToActorId: null }),
  startFullscreenPreview: (cameraId) => set((state) => ({ fullscreenPreview: true, cameraBeforeFullscreen: state.previewCameraId, previewCameraId: cameraId ?? state.previewCameraId, selectedObjectId: null, walkToActorId: null })),
  endFullscreenPreview: () => set((state) => ({ fullscreenPreview: false, previewCameraId: state.cameraBeforeFullscreen, cameraBeforeFullscreen: null })),
}));
